import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/view/home'
import VideosList from '@/components/VideoList.vue'
import Service from '@/view/training'
// import Conf from '@/view/conf'
import Partner from '@/view/partner'
import Aboutus from '@/view/aboutus'
import SEO from '@/view/seo'
import Recruit from '@/view//recruit'
import Confs from '@/view/confs'

Vue.use(Router)

const scrollBehavior = (to, from, savedPosition) => {
  if (savedPosition) {
    return savedPosition
  }
}

export default new Router({
  mode: 'history',
  scrollBehavior,
  routes: [
    { name: 'home', path: '/', component: Home },
    // { name: 'conf', path: '/conference', component: Conf },
    { name: 'video', path: '/video/:id', component: VideosList },
    { name: 'service', path: '/service', component: Service },
    { name: 'partner', path: '/partner', component: Partner },
    { name: 'confs', path: '/conference-schedule', component: Confs },
    { name: 'aboutus', path: '/aboutus', component: Aboutus },
    { name: 'seo', path: '/seo', component: SEO },
    { name: 'recruit', path: '/recruit', component: Recruit },
    { path: '*', redirect: '/' }
  ]
})
